import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken]             = useState(() => localStorage.getItem("savora_token") || "");

  const saveToken = (jwt) => {
    localStorage.setItem("savora_token", jwt);
    setToken(jwt);
  };

  const clearToken = () => {
    localStorage.removeItem("savora_token");
    setToken("");
    setCurrentUser(null);
  };

  const isLoggedIn = () => !!token;

  useEffect(() => {
    if (!token) return;
    fetch("https://api.shubhamraj01.in/api/users/profile", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(user => setCurrentUser(user))
      .catch(() => clearToken());
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser, token, saveToken, clearToken, isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);